import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../../../store';

// Hook for managing hovered class overlays and table filtering

export const useHoveredClass = () => {
  const dispatch = useDispatch();
  const microcalcOverlays = useSelector((state) => state.images.microcalcOverlaysToShow);
  const opacitiesOverlays = useSelector((state) => state.images.opacitiesOverlaysToShow);

  const [previousMicrocalcOverlays, setPreviousMicrocalcOverlays] = useState(null);
  const [previousOpacitiesOverlays, setPreviousOpacitiesOverlays] = useState(null);
  const [hoveredClass, setHoveredClassState] = useState(null);
  const [hoveredProjections, setHoveredProjections] = useState(null);

  const setHoveredClass = (highestClass, projections) => {
    const allProjections = ['rcc', 'rmlo', 'lcc', 'lmlo'];

    if (!highestClass && !projections) {
      // Restore previous overlays only when leaving an active class-hover session.
      if (hoveredClass && previousMicrocalcOverlays && previousOpacitiesOverlays) {
        dispatch(actions.setMicrocalcOverlaysToShow(previousMicrocalcOverlays));
        dispatch(actions.setOpacitiesOverlaysToShow(previousOpacitiesOverlays));
      }
      // Clear hover filter
      setHoveredClassState(null);
      setHoveredProjections(null);
      setPreviousMicrocalcOverlays(null);
      setPreviousOpacitiesOverlays(null);
      return;
    }

    // Save current state before modifying
    setPreviousMicrocalcOverlays({ ...microcalcOverlays });
    setPreviousOpacitiesOverlays({ ...opacitiesOverlays });

    // Set hover state for table filtering
    setHoveredClassState(highestClass);
    setHoveredProjections(projections);

    // Check if class exists in microcalc
    const microcalcClasses = ['vessel', 'birads2', 'birads3', 'birads4', 'birads5'];
    if (microcalcClasses.includes(highestClass)) {
      const updatedMicrocalc = Object.fromEntries(
        microcalcClasses.map((cls) => [
          cls,
          cls === highestClass
            ? {
                ...Object.fromEntries(allProjections.map((proj) => [proj, projections.includes(proj)])),
              }
            : {
                ...Object.fromEntries(allProjections.map((proj) => [proj, false])),
              },
        ])
      );
      dispatch(actions.setMicrocalcOverlaysToShow(updatedMicrocalc));
    }

    // Check if class exists in opacities
    const opacitiesClasses = ['birads2', 'birads3', 'birads4', 'birads5', 'lesionKnown'];
    if (opacitiesClasses.includes(highestClass)) {
      const updatedOpacities = Object.fromEntries(
        opacitiesClasses.map((cls) => [
          cls,
          cls === highestClass
            ? {
                ...Object.fromEntries(allProjections.map((proj) => [proj, projections.includes(proj)])),
              }
            : {
                ...Object.fromEntries(allProjections.map((proj) => [proj, false])),
              },
        ])
      );
      dispatch(actions.setOpacitiesOverlaysToShow(updatedOpacities));
    }
  };

  return { setHoveredClass, hoveredClass, hoveredProjections };
};
